<template lang="pug">
  vm-prompt(vm-size="medium" @vm-cancel="close" @vm-close="close" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="false" :vm-active="isModalShowEmployeeVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], push: true, focus: true },]")
      vm-col.card(vm-sm=12)
        h2 {{ employeershow.name }}
        div(v-if="has_permission")
          vm-table( max-height="350px" :data="employees")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('employees.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                  slot(v-if="column != 'status' && column != 'total' && column != 'unit_price' && column != 'view_payments'") {{data[indextr][column]}}
        #no-access(v-else)
          access-denied
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Customers')

export default {
  name: 'ModalShowEmployees',
  props: {
    employeershow: {
      type: Array
    }
  },
  data: () => ({
    has_permission: true,
    columns: [
      'contact',
      'email',
      'phone'
    ]
  }),
  computed: {
    ...mapGetters([
      'employees',
      'isModalShowEmployeeVisible'
    ]),
    getTitle () {
      return this.$t('strings.employees')
    }
  },
  watch: {
    isModalShowEmployeeVisible (flag) {
      if (flag) {
        this.getEmployees(1, this.employeershow.id)
      }
    }
  },
  async created () {
    this.checkPermissionView('customers.index')
  },
  methods: {
    ...mapActions([
      'loadShowEmployees',
      'loadCustomerEmployer',
      'setModalShowEmployeeVisible'
    ]),
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
    },
    close () {
      this.setModalShowEmployeeVisible(false)
    },
    async getEmployees (page, employer) {
      let t = this
      t.loadShowEmployees({ page: page, employer: employer })
    }
  }
}
</script>
<style lang="scss" scoped>
.separador-modal-btn {
  padding-right: 10px;
}
</style>
